<template>
  <div>
    <b-container class="text-center p-0 bg-gradient vh-100">
      <b-row class="bg-congrats px-4 py-4 m-0 justify-content-center vh-100">
        <b-col cols="11" sm="6" class="bg-white px-4 pt-3 pb-1">
          <p class="h3 text-uppercase font-weight-bold text-primary">C o n g r a t s !</p>
          <p class="h4">You just earned</p>
          <div class="bg-coin mx-5">
            <p class="h1 font-weight-bolder">{{getCoins}}</p>
          </div>
          <p class="mb-1">and</p>
          <p class="h5 bg-navy d-inline rounded-pill text-light py-1 px-2">{{getPoints}} pts</p>
          <p class="h4 mt-3">
            <!-- for create your
            <br />checklist in
            <br />
            <b>Homework Recording</b> -->
            {{getDescription}} 
          </p>
          <p class="h4 text-primary">Keep it up!</p>
          <small 
            class="pt-5"
            v-if="!getSelfManagementIsActive"
          >
            Remember that 
            {{getParentName}} 
            must confirm to get 
            these points.
          </small>
          <b-button @click="Next" variant="warning" class="w-100 my-2">OK!</b-button>
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
export default {
  methods: {
    Next() {
      this.$router.replace(this.$route.query.next ?? "/");
    }
  },
  computed: {
    ...mapGetters('user',['getParentName']),
    ...mapGetters('module',['getSelfManagementIsActive']),
    getCoins() {
      return this.$route.params.coins
    },
    getPoints() {
      return this.$route.params.points
    },
    getDescription() {
      return this.$route.params.description
    },
    getModule() {
      return this.$route.params.module
    },    
  },
  created(){
    if (!this.$route.params.coins){
      this.$router.replace("/");
    }
  }
};
</script>

<style scoped>
  .bg-congrats {
    background-image: url("../assets/bg-congrats.png");
    background-size: contain;
  }
  .bg-congrats .bg-white {
    height: 570px;
  }
  .bg-coin {
    background-image: url("../assets/coin.png");
    background-repeat: no-repeat;
    background-size: contain;
    background-position: center;
    color: #f6a724;
  }
  .bg-coin p {
    font-size: 4.5em;
    padding-top: 21%;
    padding-bottom: 21%;
  }
</style>